import { S as Swiper } from './swiper-core-BtjM6e_D.js';
import { N as Navigation } from './navigation-BQb6BNJ8.js';
import { A as A11y } from './a11y-BYUO09Sv.js';
import './create-element-if-not-defined-DGsapWum.js';

class ShopTheLook extends HTMLElement {
  swiper = this.querySelector('.swiper');
  nextButton = this.querySelector('.swiper-button-next');
  prevButton = this.querySelector('.swiper-button-prev');
  slideCount = this.swiper.querySelectorAll('.swiper-slide').length;

  connectedCallback() {
    this.swiperInstance = new Swiper(this.swiper, {
      modules: [A11y, Navigation],
      slidesPerView: this.slideCount > 2 ? 1.4 : 2,
      spaceBetween: 1,
      loop: true,
      navigation: {
        nextEl: this.nextButton,
        prevEl: this.prevButton,
      },
      breakpoints: {
        768: {
          slidesPerView: this.slideCount > 4 ? 3.2 : 4,
        },
        1024: {
          slidesPerView: this.slideCount > 4 ? 3.6 : 4,
        },
      },
    });
  }
}

customElements.define('shop-the-look', ShopTheLook);
